import React, { useEffect, useState, useRef } from 'react';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import TWServiceProfileLayout from '../TWServiceProfileLayout/TWServiceProfileLayout.container';
import Schedule from '../../containers/ProviderService/Schedule.container';
import PlanContainer from '../../containers/PlanContainer';
import PostPreviewList from '../../containers/Posts/PostPreviewList.container';
import { Icon } from '../../subkit-ui';
import TWReferralLink from '../TWReferralLink';
import ReviewListContainer from '../Review/ReviewList.container';
import { ServiceIntro } from './service-intro';
import ServiceNewsletterContainer from './service-newsletter/ServiceNewsletter.container';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ServiceProfile = function ServiceProfile(_ref) {
  var provider = _ref.provider,
      providerService = _ref.providerService,
      createServiceProspect = _ref.createServiceProspect,
      currentUser = _ref.currentUser,
      schedules = _ref.schedules,
      posts = _ref.posts,
      activeTab = _ref.activeTab,
      isTabSelected = _ref.isTabSelected,
      activeReferralProgram = _ref.activeReferralProgram,
      isServiceCustomer = _ref.isServiceCustomer,
      planWaitlistIds = _ref.planWaitlistIds;
  var router = useRouter();
  var tabRef = useRef(null);

  var _useState = useState(activeTab),
      tab = _useState[0],
      setTab = _useState[1];

  if (isTabSelected) {
    var _tabRef$current;

    tabRef && ((_tabRef$current = tabRef.current) === null || _tabRef$current === void 0 ? void 0 : _tabRef$current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    }));
  }

  useEffect(function () {
    setTab(activeTab);
  }, [activeTab]);
  var publishedPosts = posts.filter(function (p) {
    return p.published;
  });

  var handleTabClick = function handleTabClick(selectedTab) {
    var _providerService$prov;

    setTab(selectedTab);
    router.push({
      pathname: "/".concat(providerService === null || providerService === void 0 ? void 0 : (_providerService$prov = providerService.provider) === null || _providerService$prov === void 0 ? void 0 : _providerService$prov.slug, "/").concat(selectedTab)
    }, null, {
      scroll: false
    });
  };

  return /*#__PURE__*/_jsx(TWServiceProfileLayout, {
    classes: "bg-gray-50",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col p-4",
      "data-cy": "service-profile",
      children: [/*#__PURE__*/_jsx(ServiceIntro, {
        providerService: providerService,
        provider: provider
      }), /*#__PURE__*/_jsx("div", {
        className: "relative w-full mx-auto px-2 sm:px-4 xl:px-8 mt-10 mb-8",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-full xl:w-11/12 mx-auto test-plan-container",
          children: /*#__PURE__*/_jsx(PlanContainer, {
            providerService: providerService,
            planWaitlistIds: planWaitlistIds
          })
        })
      }), !!activeReferralProgram && /*#__PURE__*/_jsx("div", {
        className: "relative w-full mx-auto px-2 sm:px-4 xl:px-8 mb-8",
        children: /*#__PURE__*/_jsx("div", {
          className: "w-full xl:w-11/12 mx-auto",
          children: /*#__PURE__*/_jsx(TWReferralLink, {
            currentUser: currentUser,
            providerService: providerService,
            createServiceProspect: createServiceProspect,
            providerSlug: provider.slug,
            activeReferralProgram: activeReferralProgram
          })
        })
      }), !isServiceCustomer && /*#__PURE__*/_jsx("div", {
        className: "mb-8",
        children: /*#__PURE__*/_jsx(ServiceNewsletterContainer, {
          service: providerService
        })
      }), publishedPosts.length > 0 && schedules.length > 0 && /*#__PURE__*/_jsxs("div", {
        className: "flex justify-center mb-3",
        ref: tabRef,
        "data-cy": "ServiceProfileTabRoot",
        children: [/*#__PURE__*/_jsxs("div", {
          onClick: function onClick() {
            return handleTabClick('sessions');
          },
          className: classNames('clickable mr-2 rounded-full py-3 px-6', {
            'bg-yellow-300': tab === 'sessions'
          }),
          children: [/*#__PURE__*/_jsx(Icon, {
            name: "calendar",
            type: "regular",
            className: "clickable mr-1"
          }), "Sessions"]
        }), /*#__PURE__*/_jsxs("div", {
          onClick: function onClick() {
            return handleTabClick('posts');
          },
          className: classNames('clickable rounded-full py-3 px-6', {
            'bg-yellow-300': tab === 'posts'
          }),
          children: [/*#__PURE__*/_jsx(Icon, {
            name: "scroll",
            type: "regular",
            className: "clickable mr-1"
          }), "Posts"]
        })]
      }), tab === 'sessions' && schedules.length > 0 && /*#__PURE__*/_jsx("div", {
        className: "relative w-full mx-auto px-2 sm:px-4 xl:px-8 mb-14",
        "data-cy": "schedule",
        children: /*#__PURE__*/_jsx(Schedule, {
          providerService: providerService
        })
      }), ' ', tab === 'posts' && publishedPosts.length > 0 && /*#__PURE__*/_jsx(PostPreviewList, {
        provider: provider,
        providerService: providerService
      }), /*#__PURE__*/_jsx(ReviewListContainer, {
        service: providerService
      })]
    })
  });
};